
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container">
  <error [error]="error"></error>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Optional: add a "friendly name" and "Bundle ID" to each device solution.</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col pb-2">
      <list-controls [search]="devices.searchText" [limit]="devices.pageSize" [page]="devices.currentPage" [numPages]="devices.maxPages" [totalCount]="devices.filteredLength" (onChange)="devices.onListControlsChange($event)">
        <button class="btn btn-primary" (click)="save()" *ngIf="workflowTargetInfo.correctRole">Save</button>
      </list-controls>
    </div>
  </div>
  <form [formGroup]="devices.form">
    <fieldset [disabled]="isLocked || !workflowTargetInfo.correctRole">
      <div class="row">
        <div class="col pb-2" formArrayName="booleanFilters">
          <div class="form-group form-check" *ngFor="let filter of devices.booleanFilters; let i = index" [formGroupName]="i">
            <input class="form-check-input" type="checkbox" formControlName="value" autoLinkToLabel (change)="devices.booleanFilterChanged()">
            <label class="form-check-label">{{ filter.caption }}</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col" formArrayName="items">
          <div class="row" *ngFor="let device of devices.filtered; let i = index" [formGroupName]="device.index">
            <div class="col"> 
              <div class="card-item">
                <div class="row">
                  <div class="col-sm-7">
                    <property-container>
                      <property-item><strong><span class="badge badge-secondary mr-2" *ngIf="device.quicksilver">QS</span><span>
                            {{ device.type === 'accessory' ? 'Accessory - ' : '' }}{{ device.type === 'software' ? 'Software - ' : '' }}
                             {{ device.productDescription }}</span></strong></property-item>
                    </property-container>
                    <property-container>
                      <property-item>Device Key: {{ device.deviceKey }}</property-item><span class="more_info" *ngIf="device.originalSolutionKey">(ORIG: {{ device.originalSolutionKey }})</span>
                      <property-item>SKU: {{ device.productNumber }}</property-item>
                    </property-container>
                    <property-container>
                      <property-item>QTY: {{ device.stats.total | number: 0 }}</property-item>
                    </property-container>
                    <div class="col-10 pl-0 mt-2" *ngIf="device.type === 'asset' &amp;&amp; device.localizationCodes?.length"><b>Localization Codes:</b>
                      <div class="row mt-3">
                        <div class="col-md-6 mb-3" *ngFor="let localizationCode of device.localizationCodes; let i = index">
                          <div class="d-flex align-items-center">
                            <input class="mr-2" type="checkbox" id="setLocalizationCode{{i}}" [(ngModel)]="localizationCode.selected" [ngModelOptions]="{standalone: true}" (change)="devices.form.markAsDirty()"><b *ngIf="localizationCode.isDefault" style="margin-left: .6rem;">{{ localizationCode.localizationCode }}</b>
                            <localization-code-input *ngIf="!localizationCode.isDefault" [(inputModel)]="localizationCode.localizationCode" [localizationCode]="localizationCode" [device]="device" [devices]="devices"></localization-code-input>
                          </div>
                          <div [ngStyle]="{'marginLeft.rem':localizationCode.isDefault ? 1.9 : 2}"><small class="font-italic text-danger" *ngIf="localizationCode.error.length">{{ localizationCode.error }}</small><small class="font-italic text-muted" *ngIf="localizationCode.id">{{ localizationCode.localizationDescription }}</small></div>
                        </div>
                      </div>
                    </div><br>
                    <div class="col-md-12" *ngIf="device.type === 'asset' &amp;&amp; device.bundledItems?.length" style="padding:0">
                      <h6>Bundled Accessories:</h6>
                      <div class="col-sm-12" *ngFor="let child of device.bundledItems">
                        <property-container>
                          <property-item>{{ child.productNumber }} {{ child.productDescription }}</property-item>
                        </property-container>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="form-group">
                      <label *ngIf="!por721">Bundle ID:</label>
                      <div *ngIf="por721">
                        <input type="radio" formControlName="bundleNumberPrefix" id="bundleIdRadio{{i}}" value="bundle" [checked]="device.bundleConfigChecked === true" [disabled]="device.maisActive" (change)="idTypeChanged($event,device)" #bundleIdRadio>
                        <label class="pad_left_10 pad_right_10" for="bundleIdRadio">Bundle ID</label>
                        <input type="radio" formControlName="bundleNumberPrefix" id="configIdRadio{{i}}" value="config" [checked]="device.bundleConfigChecked === false" [disabled]="device.maisActive" (change)="idTypeChanged($event,device)" #configIdRadio>
                        <label class="pad_left_10" for="configIdRadio">Config ID</label><span class="btn btn-primary btn-circle-sm oi oi-question-mark ml-2" data-toggle="tooltip" data-placement="top" title="Choose 'Bundle ID' or 'Config ID' to prefix the bundle number. If no number is entered, it will remain blank despite the displayed prefix."></span>
                      </div>
                      <div *ngIf="por721"><span class="prefix-input" *ngIf="device.showBundleNumberPrefix">{{device.bundleConfigChecked==false? 'CID-':'BD-' }}</span>
                        <input class="form-control" id="bundleId{{i}}" autoLinkToLabel type="text" formControlName="bundleNumberWithoutPrefix" [ngStyle]="device.showBundleNumberPrefix ? {'width': '88%', 'display': 'inline-flex', 'border-left': 'none', 'border-radius': '0 0.25rem 0.25rem 0', 'padding-left': '0'} : {}">
                        <validation-error-display [error]="error" field="bundleNumber" [index]="device.deviceKey"></validation-error-display>
                      </div>
                      <div *ngIf="!por721">
                        <input class="form-control" id="bundleId{{i}}" autoLinkToLabel type="text" formControlName="bundleNumber">
                        <validation-error-display [error]="error" field="bundleNumber" [index]="device.deviceKey"></validation-error-display>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Friendly Name:</label>
                      <input class="form-control" autoLinkToLabel type="text" formControlName="friendlyName">
                      <validation-error-display [error]="error" field="friendlyName" [index]="device.deviceKey"></validation-error-display>
                    </div>
                    <div class="form-group form-check">
                      <input class="form-check-input" type="checkbox" formControlName="disabled" autoLinkToLabel>
                      <label class="form-check-label">Disabled</label>
                      <validation-error-display [error]="error" field="disabled" [index]="device.deviceKey"></validation-error-display>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="!devices.filtered?.length">
            <div class="col">
              <div class="card-item">
                <p class="text-center empty-table-message">There are no devices in the current view.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
</div>